import { INamedConfigResolver } from "@adapptio/lib-blueprint";
import { HexioAuthenticationOptionsSchema } from "../blueprints";

export const AuthenticationOptionsResolver: INamedConfigResolver = {
	getOptsSchemaByName: () => {
		return HexioAuthenticationOptionsSchema;
	},

	getNameList: () => []
};
